import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { Location } from "@reach/router"; //eslint-disable-line
import { StaticQuery, graphql } from "gatsby";
import ogImage from "../images/plxogimage.jpg";

const detailsQuery = graphql`
  query DefaultSEOQuery {
    site {
      siteMetadata {
        title
        description
        author
        siteUrl
      }
    }
  }
`;

function SEO({ description, lang, meta, keywords, title, image }) {
  return (
    <StaticQuery
      query={detailsQuery}
      render={(data) => {
        const metaDescription =
          description || data.site.siteMetadata.description;
        return (
          <Location>
            {({ location }) => (
              <Helmet
                htmlAttributes={{
                  lang,
                }}
                title={title}
                titleTemplate={`%s | ${data.site.siteMetadata.title}`}
                meta={[
                  {
                    name: `description`,
                    content: metaDescription,
                  },
                  {
                    property: `og:title`,
                    content: title,
                  },
                  {
                    property: `og:url`,
                    content: location.href,
                  },
                  {
                    property: `og:image`,
                    content: image || ogImage,
                  },
                  {
                    property: `og:image:width`,
                    content: 1600,
                  },
                  {
                    property: `og:image:height`,
                    content: 900,
                  },
                  {
                    property: `og:description`,
                    content: metaDescription,
                  },
                  {
                    property: `og:type`,
                    content: `website`,
                  },
                  {
                    name: `twitter:card`,
                    content: `summary`,
                  },
                  {
                    name: `twitter:creator`,
                    content: data.site.siteMetadata.author,
                  },
                  {
                    name: `twitter:title`,
                    content: title,
                  },
                  {
                    name: `twitter:description`,
                    content: metaDescription,
                  },
                ]
                  .concat(
                    keywords.length > 0
                      ? {
                          name: `keywords`,
                          content: keywords.join(`, `),
                        }
                      : []
                  )
                  .concat(meta)
                  .filter((x) => x.content)}
              />
            )}
          </Location>
        );
      }}
    />
  );
}

SEO.defaultProps = {
  lang: `sv`,
  meta: [],
  keywords: [],
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.array,
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
  image: PropTypes.string,
};

export default SEO;
